var map = {
	"./ActionsModal/Cambio.vue": 802,
	"./ActionsModal/SaveChanges.vue": 803,
	"./ActionsModal/index.vue": 246,
	"./agrocolor.vue": 2057,
	"./araporcei.vue": 2058,
	"./coplaca/ParcelasActionsMultiple.vue": 1123,
	"./coplaca/index.vue": 2059,
	"./default.vue": 2060,
	"./demo.vue": 2061,
	"./sites.vue": 293,
	"./widgets/auditorias.vue": 804,
	"./widgets/dictamenes.vue": 807,
	"./widgets/pacs.vue": 809,
	"./widgets/revisiones.vue": 806,
	"./widgets/solicitudes.vue": 805,
	"./widgets/toma_muestras.vue": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1768;